import {Pipe, PipeTransform, inject} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'translateRole',
  standalone: true,
})
export class TranslateRolePipe implements PipeTransform {
  private  translate=inject(TranslateService)
  transform(roles: any[]): any {
    if (!roles) return '';
    return roles.map(role => this.translate.instant(`ROLES.${role?.name}`))
  }
}
